exports.FEATURES = {
  EMERGENCY_MOP_OUTAGE: 'emergency_mop_outage',
  SCHEDULED_ORDERING: 'bts_scheduled_ordering',
  SCHEDULED_ORDERING_GCO: 'scheduled_ordering_gco',
  DEMYSTIFY_MENU_PDP: 'demystify_menu_pdp',
  DEMYSTIFY_REVIEW: 'demystify_previous_favorites_review',
  NEXT_GEN_LOYALTY: 'next_gen_loyalty',
  EMERGENCY_SPF_OUTAGE: 'emergency_spf_outage',
};

exports.VARIATIONS = {
  SHOW_MENU_AND_PDP_PRICING: 'menu_pdp',
  SHOW_PDP_PRICING: 'pdp',
  SHOW_NEW_REVIEW_PRICING: 'review',
};
